<lib-input class="{{layout}}"
           (valueChange)="valueChange.emit($event)"
           [colorScheme]="colorScheme"
           [invalid]="invalid"
           [showClearButton]="showClearButton"
           [inputControl]="inputControl"
           [autocomplete]="autocomplete"
           [placeholder]="placeholder"
           [focusOnInit]="focusOnInit">
  <ng-container *ngIf="searchButtonPosition === 'left'">
    <button
      *ngIf="!searching && showSearchButton"
      inputPrefix
      mat-icon-button
      aria-label="Search"
      (click)="valueChange.emit(inputControl.value)"
    >
      <mat-icon>search</mat-icon>
    </button>
    <mat-spinner
      *ngIf="searching"
      inputPrefix
      diameter="20"
      color="primary"
      strokeWidth="1"
    ></mat-spinner>
  </ng-container>
</lib-input>
<ng-container *ngIf="searchButtonPosition === 'right'">
  <button *ngIf="showSearchButton"
          class="search-button"
          aria-label="Search"
          (click)="valueChange.emit(inputControl.value)">
    <mat-icon *ngIf="!searching">search</mat-icon>
    <mat-spinner
      *ngIf="searching"
      class="mat-spinner-white"
      diameter="24"
      strokeWidth="2"
    ></mat-spinner>
  </button>
</ng-container>
